import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "popup-container inner"
}
const _hoisted_2 = { class: "popup-card" }
const _hoisted_3 = { class: "popup-image" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: "media/logos/banner.jpg",
  alt: "Womens Day Image"
}, null, -1)
const _hoisted_5 = {
  for: "popup-checkbox",
  class: "popup-checkbox-label"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "checkbox-icon" }, null, -1)
const _hoisted_7 = { class: "w-lg-900px bg-white rounded shadow-sm p-6 py-10 mx-auto row" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h1", { class: "text-dark text-center fs-20 pb-1" }, " Training Management System (TMS) ", -1)
const _hoisted_9 = {
  key: 0,
  class: "text-danger fw-bold text-center border border-secondary border-1 p-3"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("hr", { class: "border border-white bg-light" }, null, -1)
const _hoisted_11 = { class: "px-7 my-auto col-md-6" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mb-5" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "text-dark mb-3" }, "User Login")
], -1)
const _hoisted_13 = { class: "fv-row mb-10" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-6 fw-bolder text-dark" }, "Username", -1)
const _hoisted_15 = { class: "fv-plugins-message-container" }
const _hoisted_16 = { class: "fv-help-block" }
const _hoisted_17 = { class: "fv-row mb-10" }
const _hoisted_18 = { class: "d-flex flex-stack mb-2" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6 mb-0" }, "Password ", -1)
const _hoisted_20 = {
  class: "",
  style: {"position":"relative"}
}
const _hoisted_21 = { class: "fv-plugins-message-container" }
const _hoisted_22 = { class: "fv-help-block" }
const _hoisted_23 = { class: "text-center" }
const _hoisted_24 = {
  type: "submit",
  ref: "submitButton",
  id: "kt_sign_in_submit",
  class: "btn btn-lg btn-primary w-100 mb-5"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Login ", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_27 = [
  _hoisted_25,
  _hoisted_26
]
const _hoisted_28 = { class: "text-center text-md-end px-7 my-auto border-start border-secondary border-3 col-md-6 login-border" }
const _hoisted_29 = { class: "my-md-15" }
const _hoisted_30 = { class: "text-start my-auto align-items-center" }
const _hoisted_31 = /*#__PURE__*/_createStaticVNode("<div class=\"order-1 my-4 text-center text-md-start\"><p class=\"mb-0 fw-bolder fs-5\">For TMS Support</p><p class=\"mb-0\"><a href=\"mailto:tms.team@tappware.com\" target=\"_blank\" class=\"text-bold fw-bolder fs-6\"><i class=\"fa fa-envelope mr-2 text-primary\" aria-hidden=\"true\"></i>tms.team@tappware.com </a></p><p class=\"m-0 fs-6 fw-bold text-dark\"><i class=\"fa fa-phone mr-2 text-dark\" aria-hidden=\"true\" style=\"transform:rotate(90deg);\"></i> +88 01304-733951 , +88 01873-927289 </p><p class=\"m-0 fs-8 mr-2 fw-bold\" style=\"color:chocolate;\"> (Support Desk is available from 8:30 AM to 6:30 PM excluding Friday &amp; Public Holiday) </p></div>", 1)
const _hoisted_32 = { class: "order-1 my-4 text-center text-md-start" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0 fw-bolder fs-5" }, "For User Manual", -1)
const _hoisted_34 = { class: "mb-0" }
const _hoisted_35 = ["href"]
const _hoisted_36 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-book mr-2 text-primary",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_37 = { class: "mb-0" }
const _hoisted_38 = ["href"]
const _hoisted_39 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-book mr-2 text-primary",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_40 = { class: "mb-0" }
const _hoisted_41 = ["href"]
const _hoisted_42 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-book mr-2 text-primary",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("p", {
  class: "m-0 fs-8 mr-2 fw-bold",
  style: {"color":"chocolate"}
}, " Read the user guide to operate this application smoothly. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_Transition, {
      duration: "550",
      name: "nested"
    }, {
      default: _withCtx(() => [
        (_ctx.show)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("button", {
                    class: "popup-close",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.show = !_ctx.show))
                  }, "X"),
                  _hoisted_4,
                  _createElementVNode("label", _hoisted_5, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      id: "popup-checkbox",
                      class: "popup-checkbox",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args)))
                    }),
                    _hoisted_6,
                    _createTextVNode(" Don't show again ")
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      (_ctx.message)
        ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.message?.detail), 1))
        : _createCommentVNode("", true),
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_Form, {
          class: "form w-100",
          id: "kt_login_signin_form",
          onSubmit: _ctx.onSubmitLogin,
          "validation-schema": _ctx.login
        }, {
          default: _withCtx(() => [
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createVNode(_component_Field, {
                class: "form-control form-control-lg form-control-solid",
                type: "text",
                name: "username",
                autocomplete: "off"
              }),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_ErrorMessage, { name: "username" })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createVNode(_component_router_link, {
                  to: "/forgot-pass",
                  class: "link-primary fs-6 fw-bolder"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Forgot Password ? ")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_Field, {
                  class: "form-control form-control-lg form-control-solid",
                  type: _ctx.passwordFieldType,
                  name: "password",
                  autocomplete: "off"
                }, null, 8, ["type"]),
                _createElementVNode("i", {
                  class: "bi bi-eye-slash",
                  id: "togglePassword",
                  style: {"cursor":"pointer","right":"17px","font-weight":"bolder","font-size":"18px","top":"2vh","position":"absolute","width":"24px","color":"black"},
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.tooglePassword && _ctx.tooglePassword(...args)))
                })
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(_component_ErrorMessage, { name: "password" })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("button", _hoisted_24, _hoisted_27, 512)
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema"])
      ]),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _hoisted_31,
            _createElementVNode("div", _hoisted_32, [
              _hoisted_33,
              _createElementVNode("p", _hoisted_34, [
                _createElementVNode("a", {
                  href: `https://bee.seip-fd.gov.bd/storage/doc/seip_user_guide.pdf`,
                  target: "_blank",
                  class: "text-bold fs-6",
                  style: {"font-weight":"600"}
                }, [
                  _hoisted_36,
                  _createTextVNode("User Guide for SEIP ")
                ], 8, _hoisted_35)
              ]),
              _createElementVNode("p", _hoisted_37, [
                _createElementVNode("a", {
                  href: `https://bee.seip-fd.gov.bd/storage/doc/training_partner_user_guide.pdf`,
                  target: "_blank",
                  class: "text-bold fs-6",
                  style: {"font-weight":"600"}
                }, [
                  _hoisted_39,
                  _createTextVNode("User Guide for Training Partner ")
                ], 8, _hoisted_38)
              ]),
              _createElementVNode("p", _hoisted_40, [
                _createElementVNode("a", {
                  href: `https://bee.seip-fd.gov.bd/storage/doc/training_institute_user_guide.pdf`,
                  target: "_blank",
                  class: "text-bold fs-6",
                  style: {"font-weight":"600"}
                }, [
                  _hoisted_42,
                  _createTextVNode("User Guide for Training Institute ")
                ], 8, _hoisted_41)
              ]),
              _hoisted_43
            ])
          ])
        ])
      ])
    ])
  ], 64))
}